import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center" data-testid="error-boundary">
        <h2 className="text-xl font-medium">Something went wrong</h2>
        <p className="max-w-md text-muted-foreground">{String(this.state.error?.message ?? this.state.error)}</p>
        <button type="button" data-testid="error-boundary-reload-button" onClick={() => window.location.reload()}
          className="focus-ring min-h-11 rounded-xl bg-primary px-5 font-semibold text-primary-foreground">
          Reload
        </button>
      </div>
    );
  }
}
